export default [
  {
    path: '/studentSign/index',
    name: 'PageStudentSignIndex',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/studentSign/index'),
    meta: {
      modular: 48,
      title: '签到',
      keepAlive: true,
      info: '学生签到——首页'
    }
  },
  {
    path: '/studentSign/class/detail',
    name: 'PageStudentSignClassDetail',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/studentSign/classDetail'
      ),
    meta: {
      modular: 48,
      title: '签到详情',
      keepAlive: true,
      info: '学生签到——详情'
    }
  },
  {
    path: '/studentSign/statics/detail',
    name: 'PageStudentSignStaticsDetail',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/studentSign/staticsDetail'
      ),
    meta: {
      modular: 48,
      title: '统计详情',
      keepAlive: true,
      info: '学生签到——统计详情'
    }
  },
  {
    path: '/studentSign/student/detail',
    name: 'PageStudentSignStudentDetail',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/studentSign/studentDetail'
      ),
    meta: {
      modular: 48,
      title: '个人统计',
      keepAlive: true,
      info: '学生签到——个人统计'
    }
  },
  {
    path: '/studentSign/unsign/teacher',
    name: 'PageTeacherUnsign',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/studentSign/PageTeacherUnsign'
      ),
    meta: {
      modular: 48,
      title: '教师未签到列表',
      keepAlive: true,
      info: '签到——教师未签到列表'
    }
  },
  {
    path: '/studentSign/reports',
    name: 'PageSignReports',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/studentSign/PageSignReports'
      ),
    meta: {
      modular: 48,
      title: '上课签到导出',
      keepAlive: true,
      info: '签到——上课签到导出'
    }
  },
  {
    path: '/studentSign/index/signDetail',
    name: 'PageSignDetail',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/studentSign/signDetail'
      ),
    meta: {
      modular: 48,
      title: '签到详情',
      keepAlive: true,
      info: '签到——签到详情'
    }
  }
]
